import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  allFeaturesByModule: [],
}

const getters = {
  allFeaturesByModule({ analyticModuleId, admin }) {
    let url = `/feature?filterBy=analyticModule&filterById=${analyticModuleId}`
    if (admin) {
      url += '&isAnalyticAdmin=true'
    }
    return axios.get(url)
  },
}

const saves = {
  saveFeature(feature) {
    const url = `/feature/${feature.id}`
    return axios.put(url, feature)
  },
}

export default class FeaturesService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
